export function safeParseJSON(value, defaultValue = null){
  try {
    return value ? JSON.parse(value) || defaultValue : defaultValue
  } catch (error) {
    return defaultValue
  }
}
